var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClass03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55848 8.74251H1.20505C1.08714 8.74251 0.990479 8.6424 0.990479 8.52032V6.28372C0.990479 6.16163 1.08714 6.06152 1.20505 6.06152H3.55848C3.67638 6.06152 3.77304 6.16163 3.77304 6.28372V8.52032C3.77304 8.6424 3.67638 8.74251 3.55848 8.74251ZM1.41964 8.29812H3.34624V6.50347H1.41964V8.29812Z",
    fill: "#B69084"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97058 8.74342H4.61718C4.49928 8.74342 4.40259 8.64331 4.40259 8.52123V2.75149C4.40259 2.62941 4.49928 2.5293 4.61718 2.5293H6.97058C7.08849 2.5293 7.18515 2.62941 7.18515 2.75149V8.52123C7.18515 8.64331 7.08849 8.74342 6.97058 8.74342ZM4.83175 8.29903H6.75835V2.97124H4.83175V8.29903Z",
    fill: "#B69084"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3831 8.74175H8.02966C7.91175 8.74175 7.81506 8.64164 7.81506 8.51955V4.51516C7.81506 4.39308 7.91175 4.29297 8.02966 4.29297H10.3831C10.501 4.29297 10.5977 4.39308 10.5977 4.51516V8.51955C10.5977 8.64164 10.501 8.74175 10.3831 8.74175ZM8.24426 8.29735H10.1708V4.73735H8.24426V8.29735Z",
    fill: "#B69084"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.795 8.74266H11.4416C11.3237 8.74266 11.2271 8.64255 11.2271 8.52046V0.982938C11.2271 0.860853 11.3237 0.760742 11.4416 0.760742H13.795C13.913 0.760742 14.0096 0.860853 14.0096 0.982938V8.52046C14.0096 8.64255 13.913 8.74266 13.795 8.74266ZM11.6562 8.29827H13.5828V1.20513H11.6562V8.29827Z",
    fill: "#B69084"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7854 9.7608H0.214597C0.096691 9.7608 0 9.66069 0 9.5386C0 9.41652 0.096691 9.31641 0.214597 9.31641H14.7854C14.9033 9.31641 15 9.41652 15 9.5386C15 9.66069 14.9033 9.7608 14.7854 9.7608Z",
    fill: "#B69084"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClass03);
export default __webpack_public_path__ + "static/media/icon-class03.241f719799ed2de04693adda3ca9aec3.svg";
export { ForwardRef as ReactComponent };